import Button from "../ui/Button";
import { ArrowRight } from "../ui/icons";
import { COMPANY } from "../data/company";
import { trackCta } from "../lib/track";
import ArticleBody from "./ArticleBody";
import Breadcrumb from "./Breadcrumb";
import Faq from "./Faq";
import Related from "./Related";
import "./templates.css";

/** A product feature: hero with the answer first, body, FAQ, closing CTA. */
export default function FeaturePage({ entry, chunk }) {
  return (
    <article className="tpl tpl--feature">
      <div className="container tpl__inner">
        <Breadcrumb entry={entry} />
        <header className="tpl__head">
          <h1 className="t-display-2">{entry.h1}</h1>
          <p className="t-lead tpl__lead">{entry.description}</p>
        </header>

        {chunk && (
          <>
            <ArticleBody html={chunk.html} slug={entry.path} lang={entry.lang} />
            <Faq items={chunk.faq} lang={entry.lang} />
            <Related paths={chunk.related} lang={entry.lang} />
            <section className="tpl-end">
              <Button
                href={`${COMPANY.urls.console}/login`}
                variant="primary"
                size="lg"
                onClick={() => trackCta(entry.path, "feature-end")}
              >
                Start free for {COMPANY.trialDays} days
                <span className="btn__glyph">
                  <ArrowRight />
                </span>
              </Button>
            </section>
          </>
        )}
      </div>
    </article>
  );
}
